// extracted by mini-css-extract-plugin
export var layoutContainer = "_69-0";
export var layoutContainerNoRounding = "_69-6";
export var layoutContainerOpen = "_69-5";
export var layoutContainerResizing = "_69-1";
export var mainContent = "_69-2";
export var resizeDivider = "_69-3";
export var slidePanel = "_69-4";